export default __webpack_public_path__ + "b9ce9eb74b37f9b9dbaa69844d914e02.png";